<template>
     <div class="labelsContainer">
         <app-labels></app-labels>
    </div>

</template>
<script>
    import {mapActions} from "vuex";
    import Labels  from'./Labels';
    export default {
        data () {
            return {}
        },
        computed   : {},
        methods    : {},
        components : {
            appLabels : Labels
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Editor.vue